var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag"},[_vm._v(" "+_vm._s(_vm.tagName)+" ")]),_c('a',{staticClass:"tag is-delete",on:{"click":function($event){$event.preventDefault();return _vm.$emit('delete-tag')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }